import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BibliographicResourceTypeModule } from '®shared/bibliographic-resource';

import { ItemMetadataComponent } from './item-metadata.component';
import { ResourceMetadataComponent } from './resource-metadata.component';

@NgModule({
  imports: [CommonModule, BibliographicResourceTypeModule],
  declarations: [ItemMetadataComponent, ResourceMetadataComponent],
  exports: [ItemMetadataComponent, ResourceMetadataComponent],
})
export class ItemMetadataModule {}
